import {useEffect} from 'react';

/** Keep the application inside the area above a phone's software keyboard. */
export function useMobileViewport(): void {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const root = document.documentElement;
    const narrow = window.matchMedia('(max-width:900px)');
    let frame = 0;
    const clear = () => {
      root.style.removeProperty('--app-viewport-height');
      root.style.removeProperty('--app-viewport-top');
      delete root.dataset.keyboardOpen;
    };
    const update = () => {
      frame = 0;
      if (!narrow.matches) {clear(); return;}
      // Pinch zoom must magnify the page, not resize its layout to the zoomed area.
      if (Math.abs(viewport.scale - 1) > 0.05) return;
      root.style.setProperty('--app-viewport-height', `${viewport.height}px`);
      root.style.setProperty('--app-viewport-top', `${viewport.offsetTop}px`);
      const active = document.activeElement;
      const editing = active instanceof HTMLTextAreaElement ||
        (active instanceof HTMLInputElement && !['button', 'submit', 'checkbox', 'radio', 'range', 'file', 'color'].includes(active.type)) ||
        (active instanceof HTMLElement && active.isContentEditable);
      if (editing && window.innerHeight - viewport.height > 120) root.dataset.keyboardOpen = 'true';
      else delete root.dataset.keyboardOpen;
    };
    const schedule = () => {if (!frame) frame = requestAnimationFrame(update);};
    update();
    viewport.addEventListener('resize', schedule);
    viewport.addEventListener('scroll', schedule);
    window.addEventListener('resize', schedule);
    narrow.addEventListener('change', schedule);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    return () => {
      cancelAnimationFrame(frame);
      viewport.removeEventListener('resize', schedule);
      viewport.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      narrow.removeEventListener('change', schedule);
      document.removeEventListener('focusin', schedule);
      document.removeEventListener('focusout', schedule);
      clear();
    };
  }, []);
}
